// @ts-nocheck
import { Cart } from "@insite/client-framework/Services/CartService";

const isCreditCardOnlyCustomer = (cart: Cart | undefined) => {
    return cart?.paymentOptions?.paymentMethods?.every(method => method.isCreditCard || method.isPaymentProfile);
};

export default isCreditCardOnlyCustomer;
